import transformToCamelCase from './shared/transformers/toCamelCaseTransformer';
import transformToSnakeCase from './shared/transformers/toSnakeCaseTransformer';

export default {
  install(Vue, { requestQueue }) {
    if (!Vue.http) {
      throw new Error('vue-resource is not installed');
    }

    Vue.http.interceptors.push((request, next) => {
      if (request.body) {
        request.body = transformToSnakeCase(request.body);
      }

      next(response => {
        if (request.transformToCamelCase) {
          response.body = transformToCamelCase(response.body);
        }
      });
    });

    Vue.http.interceptors.push((request, next) => {
      // add query string to all requests for setting the language in responses
      // eslint-disable-next-line
      let language = localStorage.getItem('language');
      // for now server doesn't handle chinese language
      // so we use english strings for chinese
      if (language === 'ch') {
        request.params.lang = 'en';
      } else {
        request.params.lang = language;
      }
      // continue to next interceptor
      next();
    });

    Vue.http.interceptors.push((request, next) => {
      // add the http call to the RequestQueue
      requestQueue.add(request);

      // continue to next interceptor
      // with response callback
      next(() => {
        // we don't need to hold the request object
        // when the response is ready
        // removing the item from requestQueue frees the memory
        requestQueue.remove(request);
      });
    });
  },
};
